<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'OdemeDuzelt',
    props:[
        "data",
    ],
    data() {
        return {
            form: {},
            submitted: false,
        };
    }, 
    watch:{
        data(props){
            const { amount, id, subscription_id, invoice_num, direction, main_explaine, explaine } = props
            this.form = { amount, id, subscription_id, invoice_num, direction, main_explaine, explaine  }
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('odeme_duzelt')
        },
        handleSubmit(){
            this.$http.put(`/members/${this.form.subscription_id}/balances`, this.form )
                    .then(resp => {
                        notify.success(resp.data.message)
                         this.$emit('loadItems');
                    })
        }
    },
};
</script>

<template>
<b-modal id="odeme_duzelt"  title="Ödeme Düzelt"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="invoice_num">Fatura Numarası</label>
            <div class="col">
                <input
                id="invoice_num" 
                v-model="form.invoice_num"
                type="text"
                class="form-control"
                />
          </div>
        </div>
       <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="amount">
                <span v-if="form.direction == 1">Borç</span>
                <span v-else>Alacak</span>
             </label>
            <div class="col">
                <input
                id="amount" 
                v-model="form.amount"
                type="text"
                class="form-control"
                />
          </div>
        </div>
         <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="main_explaine">Açıklama</label>
            <div class="col">
                <input
                id="main_explaine" 
                v-model="form.main_explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="explaine">Açıklama2</label>
            <div class="col">
                <input
                id="explaine" 
                v-model="form.explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Kaydet
            </b-button>
        </div>
    </form>
</b-modal>
</template>